<template>
  <de-layout-content>
    <a-card title="添加成员" style="width: 100%">
      <template #extra>
        <span style="color: #ff3b30">*</span>
        <span>必填项</span>
      </template>

      <div class="tab">
        <div :class="['item', selectIndex == index ? 'active' : '']" v-for="(item, index) in tabList" :key="index"
          @click="selectTab(item, index)">
          {{ item.tab }}
        </div>
      </div>

      <div class="main">
        <div class="moduleTitle">基本信息</div>
        <div class="form">
          <a-form-model ref="formRef" :model="formData" :rules="rules"
            :label-col="{ span: 1, style: { width: '90px' } }" :wrapper-col="{ span: 14 }" @submit="handleSubmit">
            <a-form-model-item ref="headImageUrl" label="照片" prop="headImageUrl">
              <uploadImg :ImgUrl="formData.headImageUrl" @imgCallback="(url) => imgCallback(url, 'headImageUrl')">
              </uploadImg>
            </a-form-model-item>
            <a-form-model-item ref="name" label="姓名" prop="name">
              <a-input v-model="formData.name" placeholder="请输入姓名" />
            </a-form-model-item>
            <!-- <a-form-model-item label="籍贯">
              <AdministrativeArea @callBackTreeValue="(value) => athletFormTreeValue(value)"
                :treeNodeVal="formData.nativePlace" placeholder="请输入籍贯" />
            </a-form-model-item> -->
            <a-form-model-item ref="sex" label="性别" prop="sex">
              <a-radio-group v-model="formData.sex">
                <a-radio value="1">男</a-radio>
                <a-radio value="0">女</a-radio>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item ref="birthday" label="生日">
              <a-date-picker v-model="formData.birthday" type="date" valueFormat="YYYY-MM-DD" style="width: 100%"
                placeholder="请输入生日" />
            </a-form-model-item>
            <a-form-model-item ref="age" label="年龄">
              <a-input v-model="formData.age" placeholder="请输入年龄" />
            </a-form-model-item>
            <a-form-model-item ref="height" label="身高" prop="height" :rules="key == 2 ? rules.height : []">
              <a-input v-model="formData.height" suffix="cm" placeholder="请输入身高" />
            </a-form-model-item>
            <a-form-model-item ref="weight" label="体重" prop="weight" :rules="key == 2 ? rules.weight : []">
              <a-input v-model="formData.weight" suffix="kg" placeholder="请输入体重" />
            </a-form-model-item>
            <a-form-model-item ref="phone" label="手机号码" prop="phone">
              <a-input v-model="formData.phone" placeholder="请输入手机号码" />
            </a-form-model-item>
            <a-form-model-item ref="smsCode" label="验证码" prop="smsCode">
              <a-input v-model="formData.smsCode" placeholder="请输入验证码">

                <template #addonAfter>
                  <div v-if="!isSend" @click="sendCode">
                    {{ sendText }}
                  </div>
                  <div v-if="isSend">{{ countDown }}</div>
                </template>
              </a-input>
            </a-form-model-item>
            <a-form-model-item ref="idCardNo" label="身份证号" name="idCardNo">
              <a-input v-model="formData.idCardNo" placeholder="请输入身份证号" />
            </a-form-model-item>
            <a-form-model-item ref="email" label="邮箱" name="email">
              <a-input v-model="formData.email" placeholder="请输入邮箱" />
            </a-form-model-item>
            <a-form-model-item ref="address" label="家庭地址" name="address">
              <AdministrativeArea @callBackTreeValue="(value) => addressFormTreeValue(value)"
                :treeNodeVal="formData.address" placeholder="请输入家庭地址" />
            </a-form-model-item>
            <a-form-model-item ref="detailedAddress" label="详细地址" name="detailedAddress">
              <a-textarea v-model="formData.detailedAddress" showCount :maxlength="100" placeholder="请输入详细地址" />
            </a-form-model-item>
            <a-form-model-item label="所在机构" name="employer">
              <div class="wz-flex-row wz-align-center">
                <a-select v-model="formData.employer" placeholder="请选择运动中心">
                  <a-select-option :value="item.id" v-for="(item, index) in centerList" :key="index">{{ item.name
                    }}</a-select-option>
                </a-select>
              </div>
            </a-form-model-item>
            <a-form-model-item label="所在小组" name="teamId" prop="teamId">
              <a-cascader :options="sectionOptions" placeholder="请选择所在小组" :fieldNames="sectionCascaderProps"
                @change="sectionOnChange" />
            </a-form-model-item>
            <!-- 教练员 -->
            <div v-show="key != 2">
              <a-form-model-item label="职位" name="position" prop="position" :rules="key != 2 ? rules.position : []">
                <a-select v-model="formData.position" placeholder="请选择职位">
                  <a-select-option v-for="item in positionSelectList" :key="item.id" :value="item.id">{{ item.name
                    }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </div>

            <a-form-model-item ref="workingTime" label="入队时间" name="workingTime">
              <a-date-picker v-model="formData.workingTime" style="width: 100%" placeholder="请选择入队时间" />
            </a-form-model-item>
            <!-- 教练员 -->
            <a-form-model-item ref="teachingProject" label="教学项目" name="teachingProject" v-if="key != 2">
              <a-cascader v-model="formData.teachingProject" :options="sportItemData" placeholder="选择教学项目"
                :fieldNames="cascaderProps" @change="(value, options) => teachingProjectChange(value, options)
          " />
            </a-form-model-item>
            <!-- 运动员 -->
            <a-form-model-item label="训练项目" v-if="key == 2">
              <div class="wz-flex-row wz-mb-1" v-for="(item, index) in trainingProjectList" :key="index">
                <a-cascader :value="item.trainingProject" @change="(value, options) =>
            trainingProjectChange(value, options, index)
          " :options="sportItemData" :fieldNames="cascaderProps" placeholder="选择训练项目" />
                <a-button danger class="wz-ml-1" v-if="index != 0" @click="delTrainingProject(index)">删除</a-button>
              </div>
              <div class="addTrain" @click="addTrainingProject">
                +新增运动项目
              </div>
            </a-form-model-item>
            <div v-if="key == 2">
              <div class="moduleTitle">个人成绩</div>
              <a-form-model-item label="运动等级" prop="sportsLevel">
                <a-select v-model="formData.sportsLevel" placeholder="请选择运动等级">
                  <a-select-option :value="item.id" v-for="(item, index) in LevelList" :key="index">{{ item.name
                    }}</a-select-option>
                </a-select>
              </a-form-model-item>
              <a-form-model-item ref="sportPerformance" label="运动成绩" name="sportPerformance">
                <a-textarea v-model="formData.sportPerformance" showCount :maxlength="1000" placeholder="请选择运动成绩" />
              </a-form-model-item>
            </div>
            <!-- 教练,其他 -->
            <a-row>
              <a-col :span="15" v-if="key != 2">
                <div class="module">
                  <div class="moduleHeader">
                    <div class="moduleTitle">教育经历</div>
                    <div class="add" @click="doEducations(1)">
                      <PlusCircleTwoTone />
                      添加
                    </div>
                  </div>
                  <div class="moduleContent" v-for="(item, index) in educationsList" :key="index">
                    <div class="top">
                      <div class="address">
                        <span class="title">{{ item.collegeName }}</span>
                        <span class="date" style="margin-left: 22px">{{ item.startTime | momentToStr }}-{{
                          item.endTime | momentToStr
                          }}</span>
                      </div>
                      <div class="edit" @click="doEducations(2, item, index)">
                        <EditTwoTone />
                        编辑
                      </div>
                    </div>
                    <div class="bottom">
                      <span>{{ item.major }}</span>
                      <span class="wz-ml-1 wz-mr-1">|</span>
                      <!-- <span>{{
                        $filters.toIdListName(item.degree, educateData)
                      }}</span> -->
                      <span>{{ toIdListName(item.degree, educateData) }}</span>
                      <span>{{ item.degree }}</span>
                    </div>
                  </div>
                </div>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="15" v-if="key != 2">
                <div class="module">
                  <div class="moduleHeader">
                    <div class="moduleTitle">执教履历</div>
                    <div class="add" @click="doTeaches(1)">
                      <PlusCircleTwoTone />
                      添加
                    </div>
                  </div>
                  <div class="moduleContent" v-for="(item, index) in teachesList" :key="index">
                    <div class="top">
                      <div class="address">
                        <span class="title">{{ item.companyName }}</span>
                        <!-- <span class="date" style="margin-left: 22px"
                          >{{
                            $filters.momentToStr(
                              item.teachingTimeValue[0],
                              "format",
                              "YYYY-MM",
                            )
                          }}-{{
                            $filters.momentToStr(
                              item.teachingTimeValue[1],
                              "format",
                              "YYYY-MM",
                            )
                          }}</span
                        > -->
                        <span class="date" style="margin-left: 22px">{{ item.teachingTimeValue[0] | momentToStr1 }}-{{
                          item.teachingTimeValue[1] | momentToStr1
                          }}</span>
                        <span class="date" style="margin-left: 22px"></span>
                      </div>
                      <div class="edit" @click="doTeaches(2, item, index)">
                        <EditTwoTone />
                        编辑
                      </div>
                    </div>
                    <div class="bottom">
                      <div>担任职位：{{ item.position }}</div>
                      <div>工作内容: {{ item.teachingContent }}</div>
                    </div>
                  </div>
                </div>
              </a-col>
            </a-row>
            <div class="moduleTitle">其他信息</div>
            <a-form-model-item ref="remark" label="备注" name="remark">
              <a-textarea v-model="formData.remark" showCount :maxlength="1000" />
            </a-form-model-item>
            <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
              <a-button type="primary" @click="onSubmit"><i class="el-icon-check"></i>提交</a-button>
              <a-button style="margin-left: 10px" @click="resetForm"><i class="el-icon-refresh"></i>重置</a-button>
            </a-form-model-item>
          </a-form-model>
        </div>
      </div>
    </a-card>
    <!-- 添加教育经历 -->
    <a-modal :title="`${educationsInfo.type == 1 ? '添加' : '编辑'}教育经历`" v-model="educationsInfo.show"
      @ok="confirmEducations">
      <a-form :model="educationsInfo" style="width: 100%">
        <a-form-item label="学校名称" :rules="[{ required: true, message: '请输入学校名称' }]">
          <a-input v-model="educationsInfo.collegeName" placeholder="请输入学校名称" autocomplete="off" />
        </a-form-item>
        <a-form-item label="学历" :rules="[{ required: true, message: '请选择学历' }]">
          <a-select v-model="educationsInfo.degree" placeholder="请选择学历">
            <a-select-option v-for="item in educateData" :key="item.id" :value="item.id">{{ item.name
              }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="专业" :rules="[{ required: true, message: '请输入专业' }]">
          <a-input v-model="educationsInfo.major" placeholder="请输入专业" autocomplete="off" />
        </a-form-item>
        <a-form-item label="教育时间" :rules="[{ required: true, message: '请输入教育时间' }]">
          <div class="flex-row align-center">
            <a-date-picker v-model="educationsInfo.startTime" :open="yearPickShow" @panelChange="handlePanelChangeStart"
              @openChange="(status) => handleOpenChange(status, 0)" mode="year" format="YYYY" placeholder="请选择年份" />
            <span> - </span>
            <a-date-picker v-model="educationsInfo.endTime" :open="yearPickShow1" @panelChange="handlePanelChangeEnd"
              @openChange="(status) => handleOpenChange(status, 1)" mode="year" format="YYYY" placeholder="请选择年份" />
          </div>
        </a-form-item>
      </a-form>
    </a-modal>
    <!-- 添加、编辑执教履历弹框 -->
    <a-modal :title="`${teachesInfo.type == 1 ? '添加' : '编辑'}执教履历`" v-model="teachesInfo.show" @ok="confirmTeaches">
      <a-form :model="teachesInfo" style="width: 100%">
        <a-form-item label="公司名称" :rules="[{ required: true, message: '请输入公司名称' }]">
          <a-input v-model="teachesInfo.companyName" autocomplete="off" />
        </a-form-item>
        <a-form-item label="职位" :rules="[{ required: true, message: '请输入职位' }]">
          <a-input v-model="teachesInfo.position" autocomplete="off" />
        </a-form-item>
        <a-form-item label="执教时间" :rules="[{ required: true, message: '请输入执教时间' }]">
          <a-range-picker style="width: 100%" :mode="['month', 'month']" :placeholder="['开始日期', '结束日期']"
            v-model="teachesInfo.teachingTimeValue" format="YYYY-MM" :open="isRangeOpen" @openChange="openRangeChange"
            @panelChange="handlePanelChange2" @change="handleRangeChange" />
        </a-form-item>
        <a-form-item label="执教内容">
          <a-textarea v-model="teachesInfo.teachingContent" placeholder="输入内容" show-count :rows="3" :maxlength="1000" />
        </a-form-item>
      </a-form>
    </a-modal>
  </de-layout-content>
</template>

<script>
import * as API_Member from "@/api/member/member";
import axios from "axios";
import moment from "moment";
import "moment/locale/zh-cn";
import uploadImg from "@/components/uploadImg/uploadImg.vue";
import AdministrativeArea from "@/components/administrativeArea/administrativeArea.vue";
let checkAge = async (rule, value) => {
  if (!value) {
    return Promise.reject("此号码做为登录账号，请务必填写正确");
  }
  console.log(/^1[3456789]\d{9}$/.test(value));
  if (!/^1[3456789]\d{9}$/.test(value)) {
    return Promise.reject("请输入正确的手机号码格式");
  } else {
    return Promise.resolve();
  }
};
export default {
  components: {
    uploadImg,
    AdministrativeArea
  },
  data() {
    return {
      countDown: "",
      isSend: false,
      yearPickShow: false,
      yearPickShow1: false,
      isRangeOpen: false,
      sendText: "获取验证码",
      key: 2,
      selectIndex: 0,
      tabList: [
        {
          key: 2,
          tab: "运动员",
        },
        {
          key: 3,
          tab: "教练员",
        },
        {
          key: 4,
          tab: "科研医疗人员",
        },
        {
          key: 5,
          tab: "队伍管理人员",
        },
      ],
      educateData: [
        { id: 1, name: "初中及以下" },
        { id: 2, name: "中专/中技" },
        { id: 3, name: "高中" },
        { id: 4, name: "大专" },
        { id: 5, name: "本科" },
      ],
      formData: {
        sex: "1",
      },
      rules: {
        headImageUrl: [
          {
            required: true,
            message: "请上传照片",
            trigger: "change",
          },
        ],
        name: [
          {
            required: true,
            message: "请填写姓名",
            trigger: "blur",
          },
        ],
        sex: [
          {
            required: true,
            message: "请填写性别",
            trigger: "change",
          },
        ],
        height: [
          {
            required: true,
            message: "请填写身高",
            trigger: "blur",
          },
        ],
        weight: [
          {
            required: true,
            message: "请填写体重",
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            // message: "此号码做为登录账号，请务必填写正确",
            validator: checkAge,
            trigger: "blur",
          },
        ],
        smsCode: [
          {
            required: true,
            message: "请填写验证码",
            trigger: "blur",
          },
        ],
        teamId: [
          {
            required: true,
            message: "请选择所在小组",
            trigger: "change",
          },
        ],
        position: [
          {
            required: true,
            message: "请选择职位",
            trigger: "change",
          },
        ],

        sportsLevel: [
          {
            required: true,
            type: "number",
            message: "请选择运动等级",
            trigger: "change",
          },
        ],
      },
      sectionCascaderProps: {
        label: "name",
        value: "id",
        children: "children",
      },
      cascaderProps: {
        label: "name",
        value: "name",
        children: "child",
      },
      teachesInfo: {
        show: false,
        type: 1, // 1-添加 2-编辑
        id: null,
        index: null,
        companyName: null, // 公司名称
        position: null, // 职位
        teachingContent: null, // 执教内容
        teachingTime: null, // 执教时间
        teachingTimeValue: null, // 执教时间
      },
      educationsInfo: {
        show: false, // 显示弹框
        type: 1, // 1-添加 2-编辑
        collegeName: null, // 学校名称
        degree: null, // 学历
        educationTime: null, // 教育时间
        major: null, // 专业
        startTime: null,
        endTime: null,
      },
      trainingProjectList: [{ trainingProject: null, options: null }],
      areaSource: [],
      centerList: [],
      sectionOptions: [],
      positionSelectList: [],
      sportItemData: [],
      LevelList: [],
      educationsList: [],
      teachesList: [],
    };
  },
  created() {
    this.init();
  },
  mounted() { },
  methods: {
    init() {
      API_Member.getCenterSelectList().then((res) => {
        if (res.code === 200) {
          this.centerList = res.data;
        }
      });
      API_Member.getSelectGroupsList().then((res) => {
        if (res.code === 200) {
          this.sectionOptions = res.data;
        }
      });
      API_Member.getPositionSelectList().then((res) => {
        if (res.code === 200) {
          this.positionSelectList = res.data;
        }
      });
      API_Member.getSportItem().then((res) => {
        if (res.code == 200) {
          this.sportItemData = res.data;
        }
      });
      API_Member.getLevelSelectList().then((res) => {
        if (res.code === 200) {
          this.LevelList = res.data;
        }
      });
    },
    selectTab(item, index) {
      this.selectIndex = index;
      this.key = item.key;
      // this.$refs.formRef.resetFields();
      this.$refs.formRef.clearValidate();

    },
    imgCallback(imgUrl, key) {
      this.$set(this.formData, "headImageUrl", imgUrl);
    },
    // athletFormTreeValue(treeValue) {
    //   this.formData.nativePlace = treeValue;
    // },
    addressFormTreeValue(treeValue) {
      this.formData.address = treeValue;
    },
    sendCode() {
      if (!this.formData.phone) {
        this.$message.error("请输入手机号");
        return;
      }
      API_Member.loginSendSms({
        phone: this.formData.phone,
      }).then((res) => {
        console.log(res);
      });
      this.isSend = true;
      let timer = 60;
      this.countDown = `(${timer}S)`;
      const timeFun = setInterval(() => {
        --timer;
        this.countDown = `(${timer}S)`;
        if (timer === 0) {
          this.isSend = false;
          this.sendText = "重新发送";
          clearInterval(timeFun);
        }
      }, 1000);
    },
    teachingProjectChange(value, selectedOptions) {
      let str = value.join("/");
      console.log(str);
    },
    trainingProjectChange(value, selectedOptions, index) {
      console.log(value, selectedOptions, index);
      this.trainingProjectList[index].trainingProject = value;
      this.trainingProjectList[index].options = selectedOptions;
      this.setFormTrainingProject();
    },
    addTrainingProject() {
      this.trainingProjectList.push({ trainingProject: "" });
    },
    delTrainingProject(index) {
      this.trainingProjectList.splice(index, 1);
      this.setFormTrainingProject();
    },
    setFormTrainingProject() {
      let str = "";
      this.trainingProjectList.forEach((item) => {
        if (item.trainingProject) {
          str += str
            ? "," + item.trainingProject.join("/")
            : item.trainingProject.join("/");
        }
      });
      this.formData.trainingProject = str;
    },
    sectionOnChange(value, selectedOptions) {
      console.log(value, selectedOptions);
      if (selectedOptions.length) {
        let lastArr = selectedOptions[selectedOptions.length - 1];
        let teamId = lastArr.parentId ? lastArr.parentId : lastArr.id;
        let groupId = lastArr.id;
        this.$set(this.formData, "teamId", teamId);
        this.$set(this.formData, "groupId", groupId);
      }
      console.log(this.formData, "this.formData");
    },
    doEducations(type, item = {}, index) {
      if (type == 1) {
        this.educationsInfo.type = 1;
        this.educationsInfo.collegeName = null;
        this.educationsInfo.degree = undefined;
        this.educationsInfo.major = null;
        this.educationsInfo.startTime = null;
        this.educationsInfo.endTime = null;
        this.educationsInfo.show = true;
      } else {
        this.educationsInfo.type = 2;
        this.educationsInfo.id = item.id;
        this.educationsInfo.index = index;
        this.educationsInfo.collegeName = item.collegeName;
        this.educationsInfo.degree = item.degree * 1;
        this.educationsInfo.major = item.major;
        this.educationsInfo.startTime = item.startTime;
        this.educationsInfo.endTime = item.endTime;
        this.educationsInfo.show = true;
      }
    },
    confirmEducations() {
      if (!this.educationsInfo.collegeName) {
        return this.$message.error("请输入学校名称");
      }
      if (!this.educationsInfo.degree) {
        return this.$message.error("请选择学历");
      }
      if (!this.educationsInfo.major) {
        return this.$message.error("请输入专业");
      }
      if (!this.educationsInfo.startTime) {
        return this.$message.error("请选择教育开始时间");
      }
      if (!this.educationsInfo.endTime) {
        return this.$message.error("请选择教育结束时间");
      }
      if (
        new Date(this.educationsInfo.endTime).getTime() <
        new Date(this.educationsInfo.startTime).getTime()
      ) {
        return this.$message.error("教育开始时间不能小于教育结束时间");
      }
      if (this.educationsInfo.type == 1) {
        this.educationsList.push({
          id: this.educationsInfo.id ? this.educationsInfo.id : null,
          collegeName: this.educationsInfo.collegeName,
          degree: this.educationsInfo.degree * 1,
          major: this.educationsInfo.major,
          startTime: this.educationsInfo.startTime,
          endTime: this.educationsInfo.endTime,
          educationTime: `${moment(
            this.educationsInfo.startTime,
          ).valueOf()}-${moment(this.educationsInfo.endTime).valueOf()}`,
        });
      } else {
        this.educationsList[this.educationsInfo.index] = {
          id: this.educationsInfo.id ? this.educationsInfo.id : null,
          collegeName: this.educationsInfo.collegeName,
          degree: this.educationsInfo.degree * 1,
          major: this.educationsInfo.major,
          startTime: this.educationsInfo.startTime,
          endTime: this.educationsInfo.endTime,
          educationTime: `${moment(
            this.educationsInfo.startTime,
          ).valueOf()}-${moment(this.educationsInfo.endTime).valueOf()}`,
        };
      }
      console.log(this.educationsList);

      this.educationsInfo.show = false;
    },
    // 添加或修改执教履历
    doTeaches(type, item = {}, index) {
      if (type == 1) {
        this.teachesInfo.type = 1;
        this.teachesInfo.companyName = null;
        this.teachesInfo.position = null;
        this.teachesInfo.teachingTime = null;
        this.teachesInfo.teachingTimeValue = null;
        this.teachesInfo.teachingContent = null;
      } else {
        let str = item.teachingTime.split("-");
        console.log(str);
        console.log(item, "item");
        this.teachesInfo.type = 2;
        this.teachesInfo.id = item.id;
        this.teachesInfo.index = index;
        this.teachesInfo.companyName = item.companyName;
        this.teachesInfo.position = item.position;
        this.teachesInfo.teachingTime = item.teachingTime;
        this.teachesInfo.teachingTimeValue = item.teachingTimeValue;
        this.teachesInfo.teachingContent = item.teachingContent;
      }
      this.teachesInfo.show = true;
    },
    confirmTeaches() {
      if (!this.teachesInfo.companyName) {
        return this.$message.error("请输入公司名称");
      }
      if (!this.teachesInfo.position) {
        return this.$message.error("请输入职位");
      }
      if (!this.teachesInfo.teachingTimeValue) {
        return this.$message.error("请选择执教时间");
      }
      // if (!this.teachesInfo.teachingContent) {
      //   return message.error("请输入执教内容");
      // }

      if (this.teachesInfo.type == 1) {
        // 添加
        this.teachesList.push({
          companyName: this.teachesInfo.companyName,
          position: this.teachesInfo.position,
          teachingTimeValue: this.teachesInfo.teachingTimeValue,
          teachingTime: `${moment(
            this.teachesInfo.teachingTimeValue[0],
          ).valueOf()}-${moment(
            this.teachesInfo.teachingTimeValue[1],
          ).valueOf()}`,
          teachingContent: this.teachesInfo.teachingContent,
        });
      } else {
        this.teachesList[this.teachesInfo.index] = {
          id: this.teachesInfo.id ? this.teachesInfo.id : null,
          companyName: this.teachesInfo.companyName,
          position: this.teachesInfo.position,
          teachingTimeValue: this.teachesInfo.teachingTimeValue,
          teachingTime: `${moment(
            this.teachesInfo.teachingTimeValue[0],
          ).valueOf()}-${moment(
            this.teachesInfo.teachingTimeValue[1],
          ).valueOf()}`,
          teachingContent: this.teachesInfo.teachingContent,
        };
      }
      console.log(this.teachesList);

      this.teachesInfo.show = false;
    },
    handleOpenChange(status, type) {
      if (type == 0) {
        this.yearPickShow = status;
      } else {
        this.yearPickShow1 = status;
      }
    },
    handlePanelChangeStart(value) {
      this.educationsInfo.startTime = value;
      this.yearPickShow = false;
    },
    handlePanelChangeEnd(value) {
      this.educationsInfo.endTime = value;
      this.yearPickShow1 = false;
    },
    openRangeChange(status) {
      if (status) {
        this.isRangeOpen = true;
      } else {
        this.isRangeOpen = false;
      }
    },
    handlePanelChange2(value) {
      this.teachesInfo.teachingTimeValue = value;
      console.log(this.teachesInfo.teachingTimeValue);
      this.isRangeOpen = false;
    },
    toIdListName(id, list, key = "name") {
      for (let i = 0; i < list.length; i++) {
        if (list[i].id == id) {
          return list[i][key];
        }
      }
    },

    onSubmit() {
      this.$refs.formRef
        .validate()
        .then(() => {
          let achieves = {
            remark: "",
            sportPerformance: this.formData.sportPerformance || "",
            sportsLevel: this.formData.sportsLevel || "",
          }; // 个人成绩-运动员
          let educations = this.educationsList; // 教育经历-教练|科研人员
          let teaches = this.teachesList; // 执教经历-教练|科研人员
          let data = {};
          if (this.key == 2) {
            data = {
              ...this.formData,
              achieves: achieves,
              type: this.key,
              workingTime: moment(this.formData.workingTime).valueOf(),
              birthday: moment(this.formData.birthday).valueOf(),
            };
          } else {
            console.log(this.formData.teachingProject);
            data = {
              ...this.formData,
              educations: educations,
              teachingProject: this.formData.teachingProject
                ? this.formData.teachingProject.join("/")
                : "",
              teaches: teaches,
              type: this.key,
              workingTime: moment(this.formData.workingTime).valueOf(),
              birthday: moment(this.formData.birthday).valueOf(),
            };
          }
          console.log(data);
          API_Member.memberAdd(data)
            .then((res) => {
              console.log(res);
              if (res.code === 200) {
                this.$message.success(res.msg);
                this.$router.go(-1);
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch((err) => {
              this.$message.error(err.msg);
            });
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    resetForm() {
      this.$refs.formRef.resetFields();
    },
  },
  filters: {
    momentToStr(value) {
      return moment(value).format("YYYY");
    },
    momentToStr1(value) {
      return moment(value).format("YYYY-MM");
    },
  },
  computed: {
    // toIdListName(id, list, key = "name") {
    //   for (let i = 0; i < list.length; i++) {
    //     if (list[i].id == id) {
    //       return list[i][key];
    //     }
    //   }
    // },
  },
};
</script>

<style scoped lang="less">
.tab {
  display: flex;

  .item {
    width: 180px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    border-radius: 6px;
    border: 1px solid #f2f2f2;
    margin-right: 32px;
    cursor: pointer;
  }

  .active {
    border-color: #1890FF;
    color: #1890FF;
  }
}

.main {
  .moduleTitle {
    height: 68px;
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: bold;
  }

  .moduleTitle::before {
    content: "▋";
    display: inline-block;
    color: #40a1ff;
  }

  .addTrain {
    width: 100%;
    height: 32px;
    color: #1890FF;
    border: 1px solid #1890FF;
    text-align: center;
    line-height: 32px;
    margin-top: 22px;
    cursor: pointer;
    border-radius: 4px;

    &:hover {
      background-color: #1890FF;
      color: #fff;
    }
  }

  .moduleHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .moduleContent {
    padding:10px 15px;
    background-color: #21284b;
    border-radius: 3px;
  }

  .moduleContent .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  .moduleContent .bottom div {
    margin-bottom: 12px;
  }
}
</style>
